"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h3", {
  className: "text-muted"
}, "Waiting List");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", {
  className: "text-muted"
}, "Please be aware that the order of the waiting list will change as your relative position on the ranking lists changes.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", {
  className: "text-muted"
}, "Although the list is in order (based on current rankings) there may be additional entries not shown on this list, eg paddlers waiting for bib number confirmation. These paddlers may be higher up the list than you.");
var _ref4 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted"
}, "RTC");
var _ref5 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted"
}, "Race");
var _ref6 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted text-xs-right"
}, "Bib");
var _ref7 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted"
}, "Name");
var _ref8 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted"
}, "Ranking");
var _ref9 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted"
}, "Age");
var _ref10 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-muted"
}, "Club");
var _ref11 = /*#__PURE__*/_react.default.createElement("th", null);
class WaitingList extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, !this.props.waitingList.length ? null : /*#__PURE__*/_react.default.createElement("div", null, _ref, _ref2, _ref3, /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, !this.props.displayFreeCode ? null : _ref11)), /*#__PURE__*/_react.default.createElement("tbody", null, this.props.waitingList.map(entry => /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted"
    }, entry.rtcRefs.join('')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted"
    }, entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted text-xs-right"
    }, entry.startListBib), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted"
    }, entry.bibName), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted"
    }, entry.rankingDivisionDescription, " ", entry.classDescription, entry.bibNumber ? ' Bib ' + entry.bibNumber : ''), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted"
    }, entry.ageCategoryDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted"
    }, entry.entryText), !this.props.displayFreeCode ? null : /*#__PURE__*/_react.default.createElement("td", null, entry.freeCode)))))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(WaitingList, "partials", {
  WaitingList: {
    id: true,
    classDescription: true,
    bibNumber: true,
    startListBib: true,
    bibName: true,
    entryText: true,
    rtcRefs: true,
    freeCode: true,
    ageCategoryDescription: true,
    rankingDivisionDescription: true,
    race: {
      raceName: true
    }
  }
});
var _default = exports.default = WaitingList;